import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SelectCompanyContainer } from '../modules/company/SelectCompanyContainer';
import { LoginContainer } from '../modules/login/LoginContainer';
import { OrganizationContainer } from '../modules/orgs/OrgsContainer';
import { ConsoleUsersContainer } from '../modules/users/ConsoleUsersContainer';
import { AuthenRouterContainer } from './AuthenRouter';

import { Component404 } from '../modules/404/404Compopnent';
import { EmptyCompanyContainer } from '../modules/company/create-company/EmptyCompanyContainer';
import { LogoutContainer } from '../modules/login/LogoutContainer';
import { LinkOrgsContainer } from '../modules/orgs/link-orgs/LinkOrgsContainer';
import { SystemSettingContainer } from '../modules/system-setting/SystemSettingContainer';
import { ConsoleUsersActivityContainer } from '../modules/users/activity/ConsoleUsersActivityContainer';
import { UserCompanyContainer } from '../modules/users/company/UserCompanyContainer';
import { ConsoleSPUsersContainer } from '../modules/users/ConsoleSPUsersContainer';
import { ExportsHistoryContainer } from '../modules/users/exports-history/ExportsHistoryContainer';
import { ChangePasswordContainer } from '../modules/users/info/ChangePasswordContainer';
import { NotificationContainer } from '../modules/users/info/NotificationContainer';
import { TwoFaContainer } from '../modules/users/info/TwoFaContainer';
import { UserApiContainer } from '../modules/users/info/UserApiContainer';
import { UserInfoContainer } from '../modules/users/info/UserInfoContainer';
import { UserTokenContainer } from '../modules/users/info/UserTokenContainer';
import { InviteUserToOrgContainer } from '../modules/users/invite/InviteUserToOrgContainer';
import { LoginActivityContainer } from '../modules/users/login-activity/LoginActivityContainer';
import { PermissionGroupContainer } from '../modules/users/permisions/PerminssionGroupContainer';
import { UserProfileContainer } from '../modules/users/profile/UserProfileContainer';
import { UserPwdContainer } from '../modules/users/pwd/UserPwdContainer';
import { SuperPermissionContainer } from '../modules/users/super-permission/SuperPermissionContainer';
import { InternalPermissionContainer } from '../modules/users/internal_permission/InternalPermissionContainer';

class MainRouter extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/login" component={LoginContainer} />
        <Route exact path="/logout" component={LogoutContainer} />
        <AuthenRouterContainer exact path="/dashboard" component={UserInfoContainer} failComponent={LoginContainer} />
        <AuthenRouterContainer exact path="/" component={UserInfoContainer} failComponent={LoginContainer} />
        <AuthenRouterContainer
          exact
          path="/my-account-info"
          component={UserInfoContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/notifications"
          component={NotificationContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/security/2fa-security"
          component={TwoFaContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/security/change-password"
          component={ChangePasswordContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/security/my-account-tokens"
          component={UserTokenContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/security/my-account-api"
          component={UserApiContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/my-account-change-pwd"
          component={UserPwdContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/organization"
          component={UserCompanyContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/activity/invitation"
          component={InviteUserToOrgContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/activity/"
          component={InviteUserToOrgContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/activity/exports-history"
          component={ExportsHistoryContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/activity/exports-history/:id"
          component={ExportsHistoryContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/companies/empty"
          component={EmptyCompanyContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/companies/select"
          component={SelectCompanyContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/console-organizations"
          component={OrganizationContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/console-users"
          component={ConsoleUsersContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/super-admin-console-users"
          component={ConsoleSPUsersContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/console-link-orgs"
          component={LinkOrgsContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/console-system-setting"
          component={SystemSettingContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/console-activity"
          component={ConsoleUsersActivityContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/permission-group"
          component={PermissionGroupContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer exact path="/profile" component={UserProfileContainer} failComponent={LoginContainer} />
        <AuthenRouterContainer
          exact
          path="/console-permission"
          component={SuperPermissionContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/internal-permission"
          component={InternalPermissionContainer}
          failComponent={LoginContainer}
        />
        <AuthenRouterContainer
          exact
          path="/activity/login-history"
          component={LoginActivityContainer}
          failComponent={LoginContainer}
        />
        <Route path="*" component={Component404}></Route>
      </Switch>
    );
  }
}

export default MainRouter;
